export default __webpack_public_path__ + "static/media/allinfra1.8051a6fe.png";